interface ActionType {
  CREATE_CHECKOUT_SESSION_START: string;
  CREATE_CHECKOUT_SESSION_SUCCESS: string;
  CREATE_CHECKOUT_SESSION_FAILURE: string;
  CHECK_CHECKOUT_SESSION_STATUS_START: string;
  CHECK_CHECKOUT_SESSION_STATUS_SUCCESS: string;
  CHECK_CHECKOUT_SESSION_STATUS_FAILURE: string;
  GET_PAYMENT_TYPE_PRICE_START: string;
  GET_PAYMENT_TYPE_PRICE_SUCCESS: string;
  GET_PAYMENT_TYPE_PRICE_FAILURE: string;
  CONFIRM_POST_PAYMENT_START: string;
  CONFIRM_POST_PAYMENT_SUCCESS: string;
  CONFIRM_POST_PAYMENT_FAILURE: string;
  CLEAR_PAYMENT_STATE: string;
}

export const PaymentActionTypes: ActionType = {
  CREATE_CHECKOUT_SESSION_START: '@@CREATE_CHECKOUT_SESSION_START',
  CREATE_CHECKOUT_SESSION_SUCCESS: '@@CREATE_CHECKOUT_SESSION_SUCCESS',
  CREATE_CHECKOUT_SESSION_FAILURE: '@@CREATE_CHECKOUT_SESSION_FAILURE',
  CHECK_CHECKOUT_SESSION_STATUS_START: '@@CHECK_CHECKOUT_SESSION_STATUS_START',
  CHECK_CHECKOUT_SESSION_STATUS_SUCCESS:
    '@@CHECK_CHECKOUT_SESSION_STATUS_SUCCESS',
  CHECK_CHECKOUT_SESSION_STATUS_FAILURE:
    '@@CHECK_CHECKOUT_SESSION_STATUS_FAILURE',
  GET_PAYMENT_TYPE_PRICE_START: '@@GET_PAYMENT_TYPE_PRICE_START',
  GET_PAYMENT_TYPE_PRICE_SUCCESS: '@@GET_PAYMENT_TYPE_PRICE_SUCCESS',
  GET_PAYMENT_TYPE_PRICE_FAILURE: '@@GET_PAYMENT_TYPE_PRICE_FAILURE',
  CONFIRM_POST_PAYMENT_START: '@@CONFIRM_POST_PAYMENT_START',
  CONFIRM_POST_PAYMENT_SUCCESS: '@@CONFIRM_POST_PAYMENT_SUCCESS',
  CONFIRM_POST_PAYMENT_FAILURE: '@@CONFIRM_POST_PAYMENT_FAILURE',
  CLEAR_PAYMENT_STATE: '@@CLEAR_PAYMENT_STATE'
};

export interface PaymentState {
  checkoutSessionSecret?: string;
  checkingOut?: boolean;
  checkingCheckoutSessionStatus?: boolean;
  postPaymentId?: number;
  confirmingPostPayment?: boolean;
  postPaymentConfirmed?: boolean;
  checkoutSessionStatus?: 'COMPLETED' | 'FAILED';
  error?: string;
  gettingPaymentTypePrice?: boolean;
  paymentTypePrice?: number;
  priceIncludeTax?: boolean;
  paymentIntentId?: string;
}

export interface CreateCheckoutSessionPayload {
  paymentType: string;
  returnUrl: string;
  quantity?: number;
  metaData?: object;
}
